module.exports = require('../../es/string/repeat');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/features/string/repeat.js
// module id = 556
// module chunks = 0